import Link from 'next/link';
import { memo, type PropsWithChildren } from 'react';

import { AirIcon } from '@air/design-icons';

export const AppErrorBackground = memo(({ children }: PropsWithChildren<object>) => (
  <main className="relative flex h-screen bg-gradient-to-b from-blue-3 to-blue-1">
    <div className="z-1 mx-auto flex h-[calc(100vh-52px)] max-w-[500px] flex-1 flex-col items-center justify-center gap-4 p-8 text-center">
      <Link href="https://air.inc">
        <AirIcon className="absolute top-10 left-8 ads:text-icon-emphasis text-gray-12" size={65} />
      </Link>
      {children}
    </div>
  </main>
));

AppErrorBackground.displayName = 'AppErrorBackground';
